// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__sYRcl","sm":"Divider_sm__ngg7t","lg":"Divider_lg__MiizM"};